/**
 * Legacy ProxyUserApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.proxyUserApi`) keep resolving.
 *
 * The actual UserProxyApiService is now exposed through the Angular 18
 * ApiService facade as `apiService.userProxy`. Implementation:
 *   apps/b2b-frontend/app/core/api/user-proxy/user-proxy-api.service.ts
 */
angular.module("acme.common.service.proxyUserApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
